(function () {
  "use strict";

  const STUDY_REFERENCES = [
    {
      number: "01",
      url: "https://www.nature.com/articles/437045a"
    },
    {
      number: "02",
      url: "https://www.nejm.org/doi/full/10.1056/NEJMoa1800389"
    },
    {
      number: "03",
      url: "https://pmc.ncbi.nlm.nih.gov/articles/PMC7601817/"
    },
    {
      number: "04",
      url: "https://pmc.ncbi.nlm.nih.gov/articles/PMC5504696/"
    },
    {
      number: "05",
      url: "https://www.clinicalnutritionjournal.com/article/S0261-5614%2823%2900212-1/fulltext"
    }
  ];

  let selectedInterval = "30";
  let applyQueued = false;
  let cartOpenFrom = null;
  let cartScrollPosition = 0;

  function createStudyLink(reference, title) {
    const link = document.createElement("a");
    link.className = "olivex-study-link";
    link.href = reference.url;
    link.target = "_blank";
    link.rel = "noopener noreferrer";
    link.setAttribute("aria-label", `Åpne studien «${title}» i en ny fane`);

    const icon = document.createElement("span");
    icon.className = "olivex-icon olivex-icon--external";
    icon.setAttribute("aria-hidden", "true");
    link.append(icon);
    return link;
  }

  function createAprilStudy() {
    const study = document.createElement("article");
    // This card is appended after Jakob's reveal observer has already bound.
    // Keep it visible inside the horizontal rail instead of leaving it at the
    // observer's pre-animation opacity.
    study.className = "study in-view";
    study.innerHTML = [
      '<span class="study-journal">Clinical Nutrition</span>',
      '<h3>APRIL-studien (Clinical Nutrition)</h3>',
      '<p>Randomisert klinisk studie av høyfenolisk extra virgin olivenolje og kardiometabolske markører.</p>'
    ].join("");
    return study;
  }

  function updateStudyCarousel(carousel) {
    const viewport = carousel.querySelector("[data-olivex-study-viewport]");
    const rail = carousel.querySelector(".studies");
    const next = carousel.querySelector("[data-olivex-study-next]");
    if (!viewport || !rail) return;

    const maxScroll = Math.max(0, viewport.scrollWidth - viewport.clientWidth);
    const atEnd = maxScroll <= 2 || viewport.scrollLeft >= maxScroll - 2;
    carousel.classList.toggle("is-at-end", atEnd);
    if (next) {
      next.disabled = atEnd;
      next.setAttribute("aria-disabled", String(atEnd));
    }
  }

  function studyScrollAmount(carousel) {
    const card = carousel.querySelector(".study");
    const rail = carousel.querySelector(".studies");
    if (!card || !rail) return 320;
    const styles = window.getComputedStyle(rail);
    return card.getBoundingClientRect().width + (parseFloat(styles.columnGap || styles.gap) || 18);
  }

  function initializeStudyCarousel(carousel) {
    if (carousel.dataset.olivexStudyReady === "true") return;
    const viewport = carousel.querySelector("[data-olivex-study-viewport]");
    const next = carousel.querySelector("[data-olivex-study-next]");
    if (!viewport || !next) return;
    carousel.dataset.olivexStudyReady = "true";

    let scrollFrame = 0;
    const scheduleUpdate = () => {
      window.cancelAnimationFrame(scrollFrame);
      scrollFrame = window.requestAnimationFrame(() => updateStudyCarousel(carousel));
    };
    const scrollByCard = (direction) => viewport.scrollBy({
      left: studyScrollAmount(carousel) * direction,
      behavior: window.matchMedia("(prefers-reduced-motion: reduce)").matches ? "auto" : "smooth"
    });

    next.addEventListener("click", () => scrollByCard(1));
    viewport.addEventListener("scroll", scheduleUpdate, { passive: true });
    viewport.addEventListener("keydown", (event) => {
      if (event.key !== "ArrowLeft" && event.key !== "ArrowRight") return;
      event.preventDefault();
      scrollByCard(event.key === "ArrowRight" ? 1 : -1);
    });
    window.addEventListener("resize", scheduleUpdate, { passive: true });
    scheduleUpdate();
  }

  function ensureReferences() {
    document.querySelectorAll(".olivex-approved-references, .olivex-reference-index").forEach((section) => section.remove());

    const research = document.querySelector("#forskning");
    const studies = research?.querySelector(":scope .studies");
    if (!research || !studies) return;

    if (studies.children.length === 4) studies.append(createAprilStudy());
    Array.from(studies.querySelectorAll(":scope > .study")).forEach((study, index) => {
      // Horizontal discovery is handled by the carousel itself. Cards that
      // begin outside the viewport must still paint when the user scrolls to
      // them, including the dynamically-added APRIL card.
      study.classList.remove("reveal");
      study.classList.add("in-view");
      const reference = STUDY_REFERENCES[index];
      if (!reference) return;
      let number = study.querySelector(":scope > .olivex-study-number");
      if (!number) {
        number = document.createElement("span");
        number.className = "olivex-study-number";
        study.prepend(number);
      }
      // Guard: an unconditional write fires a childList mutation, which wakes
      // the observer and schedules a new frame — a permanent rAF loop.
      if (number.textContent !== reference.number) number.textContent = reference.number;
      if (!study.querySelector(":scope > .olivex-study-link")) {
        study.append(createStudyLink(reference, study.querySelector("h3")?.textContent.trim() || "forskningsreferanse"));
      }
    });

    let carousel = studies.closest("[data-olivex-study-carousel]");
    if (!carousel) {
      carousel = document.createElement("div");
      carousel.className = "olivex-study-carousel";
      carousel.dataset.olivexStudyCarousel = "";

      const viewport = document.createElement("div");
      viewport.className = "olivex-study-viewport";
      viewport.dataset.olivexStudyViewport = "";
      viewport.tabIndex = 0;
      viewport.setAttribute("role", "region");
      viewport.setAttribute("aria-label", "Fem forskningsstudier. Bruk piltastene for å bla horisontalt.");

      studies.insertAdjacentElement("beforebegin", carousel);
      carousel.append(viewport);
      viewport.append(studies);
    }

    carousel.querySelector(".olivex-study-controls")?.remove();
    if (!carousel.querySelector("[data-olivex-study-next]")) {
      const edgeButton = document.createElement("button");
      edgeButton.className = "olivex-study-edge-control";
      edgeButton.type = "button";
      edgeButton.dataset.olivexStudyNext = "";
      edgeButton.setAttribute("aria-label", "Vis neste studie");
      edgeButton.innerHTML = '<span class="olivex-icon olivex-icon--right" aria-hidden="true"></span>';
      carousel.append(edgeButton);
    }
    initializeStudyCarousel(carousel);
  }

  function ensureEditorialSections() {
    const props = document.querySelector("section.props");
    const howto = document.querySelector("section.howto");
    props?.setAttribute("data-olivex-editorial-branch", "five");
    howto?.setAttribute("data-olivex-editorial-branch", "three");
    const propsCta = Array.from(props?.querySelectorAll(".prop-card") || []).find(
      (card) => card.querySelector("h3")?.textContent.trim() === "Smak forskjellen selv"
    );
    propsCta?.remove();
    props?.querySelectorAll(".prop-card .prop-num").forEach((number, index) => {
      const numbering = String(index + 1).padStart(2, "0");
      if (number.textContent !== numbering) number.textContent = numbering;
    });

    const buySection = document.querySelector("#bestill");
    if (buySection && !buySection.querySelector(".olivex-buy-product-art")) {
      const productArt = document.createElement("img");
      productArt.className = "olivex-buy-product-art";
      productArt.src = (window.OLIVEX_ASSETS || {}).productArt || "";
      productArt.alt = "";
      productArt.width = 1200;
      productArt.height = 900;
      productArt.loading = "lazy";
      productArt.decoding = "async";
      productArt.setAttribute("aria-hidden", "true");
      buySection.prepend(productArt);
    }
  }

  function createVideoControls() {
    const fragment = document.createDocumentFragment();
    const embed = document.createElement("div");
    const play = document.createElement("button");
    const disc = document.createElement("span");
    const icon = document.createElement("img");
    const status = document.createElement("p");

    embed.className = "olivex-grove-video-embed";
    embed.dataset.olivexGroveVideoEmbed = "";

    play.className = "olivex-grove-video-play";
    play.type = "button";
    play.dataset.olivexGroveVideoPlay = "";
    play.setAttribute("aria-label", "Spill av video fra olivenlunden i Hellas");

    disc.className = "olivex-grove-play-disc";
    disc.setAttribute("aria-hidden", "true");
    icon.src = (window.OLIVEX_ASSETS || {}).playIcon || "";
    icon.alt = "";
    icon.width = 256;
    icon.height = 256;
    disc.append(icon);
    play.append(disc);

    status.className = "olivex-video-status";
    status.dataset.olivexGroveVideoStatus = "";
    status.setAttribute("aria-live", "polite");

    fragment.append(embed, play, status);
    return fragment;
  }

  function initializeVideo(frame) {
    if (frame.dataset.olivexVideoInitialized === "true") return;

    const play = frame.querySelector("[data-olivex-grove-video-play]");
    const disc = frame.querySelector(".olivex-grove-play-disc");
    const embed = frame.querySelector("[data-olivex-grove-video-embed]");
    const status = frame.querySelector("[data-olivex-grove-video-status]");
    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

    if (!play || !embed) return;
    frame.dataset.olivexVideoInitialized = "true";

    play.addEventListener("click", () => {
      if (frame.classList.contains("is-video-active")) return;

      const iframe = document.createElement("iframe");
      iframe.src = "https://www.youtube-nocookie.com/embed/P5aSmPtzSaM?rel=0&playsinline=1&autoplay=1";
      iframe.title = "Video fra olivenlunden i Hellas";
      iframe.allow = "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share";
      iframe.allowFullscreen = true;
      iframe.referrerPolicy = "strict-origin-when-cross-origin";
      iframe.tabIndex = 0;

      embed.replaceChildren(iframe);
      frame.classList.add("is-video-active");
      frame.closest(".heritage")?.classList.add("is-video-active");
      play.remove();
      if (status) status.textContent = "Videoen er lastet og spiller.";

      iframe.addEventListener("load", () => iframe.focus({ preventScroll: true }), { once: true });
      window.requestAnimationFrame(() => iframe.focus({ preventScroll: true }));
    });

    if (disc && window.matchMedia("(hover: hover) and (pointer: fine)").matches && !reducedMotion.matches) {
      // Knappen lener seg mot pekeren over HELE videoflaten, ikke bare naar
      // pekeren er over selve knappen — da leses flaten som video, ikke bilde.
      const surface = frame;
      surface.addEventListener("pointermove", (event) => {
        if (frame.classList.contains("is-video-active")) return;
        const rect = play.getBoundingClientRect();
        const centerX = rect.left + rect.width / 2;
        const centerY = rect.top + rect.height / 2;
        const pull = 0.08;
        const maxTravel = Math.min(72, rect.width * 0.75);
        const dx = Math.max(-maxTravel, Math.min(maxTravel, (event.clientX - centerX) * pull));
        const dy = Math.max(-maxTravel, Math.min(maxTravel, (event.clientY - centerY) * pull));
        disc.style.setProperty("--olivex-video-magnet-x", `${dx.toFixed(1)}px`);
        disc.style.setProperty("--olivex-video-magnet-y", `${dy.toFixed(1)}px`);
      });
      surface.addEventListener("pointerleave", () => {
        disc.style.setProperty("--olivex-video-magnet-x", "0px");
        disc.style.setProperty("--olivex-video-magnet-y", "0px");
      });
    }
  }

  function initializeGroveScrollReveal(frame, heritage) {
    if (frame.dataset.olivexScrollRevealReady === "true") return;
    frame.dataset.olivexScrollRevealReady = "true";

    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");
    if (reducedMotion.matches) return;

    // Ported from the approved checkpoint choreography:
    //   clip inset 7% / 5% -> 0
    //   section top 85% -> 22% of the viewport
    // The requestAnimationFrame interpolation reproduces GSAP's scrubbed
    // response without adding a new runtime dependency to Jakob's bundle.
    let current = 0;
    let target = 0;
    let animationFrame = 0;
    let lastTime = performance.now();

    const progressForPosition = () => {
      const sectionTop = heritage.getBoundingClientRect().top;
      const start = window.innerHeight * 0.85;
      const end = window.innerHeight * 0.22;
      return Math.min(1, Math.max(0, (start - sectionTop) / Math.max(1, start - end)));
    };

    const render = (progress) => {
      const remaining = 1 - progress;
      frame.style.clipPath = `inset(${(7 * remaining).toFixed(3)}% ${(5 * remaining).toFixed(3)}% round ${(8 * remaining).toFixed(3)}px)`;
    };

    const animate = (time) => {
      const elapsed = Math.min(64, Math.max(0, time - lastTime));
      lastTime = time;
      current += (target - current) * (1 - Math.exp(-elapsed / 170));

      if (Math.abs(target - current) < 0.001) current = target;
      render(current);

      if (current !== target) {
        animationFrame = window.requestAnimationFrame(animate);
      } else {
        animationFrame = 0;
      }
    };

    const update = () => {
      target = progressForPosition();
      if (!animationFrame) {
        lastTime = performance.now();
        animationFrame = window.requestAnimationFrame(animate);
      }
    };

    current = target = progressForPosition();
    frame.classList.add("olivex-grove-scroll-reveal");
    render(current);
    window.addEventListener("scroll", update, { passive: true });
    window.addEventListener("resize", update, { passive: true });
  }

  function ensureVideo() {
    document.querySelectorAll('[data-olivex-approved-delta="producer-video"]').forEach((section) => section.remove());

    const heritage = document.querySelector("section.heritage");
    const imageSlot = heritage?.querySelector("#grove-full");
    if (!heritage || !imageSlot) return;

    imageSlot.removeAttribute("data-olivex-video-frame");
    imageSlot.removeAttribute("data-olivex-approved-delta");
    imageSlot.querySelectorAll(".olivex-grove-video-embed, .olivex-grove-video-play, .olivex-video-status").forEach((control) => control.remove());

    let frame = heritage.querySelector("[data-olivex-video-frame]");
    if (!frame || !frame.contains(imageSlot)) {
      frame?.remove();
      frame = document.createElement("div");
      frame.className = "olivex-grove-video-frame";
      frame.dataset.olivexVideoFrame = "";
      frame.dataset.olivexApprovedDelta = "grove-video";
      imageSlot.insertAdjacentElement("beforebegin", frame);
      frame.append(imageSlot);
    }
    if (!frame.querySelector("[data-olivex-grove-video-embed]")) {
      frame.append(createVideoControls());
    }
    initializeGroveScrollReveal(frame, heritage);
    initializeVideo(frame);
  }

  function formatNok(value) {
    const hasDecimals = Math.round(value * 100) % 100 !== 0;
    return `${new Intl.NumberFormat("nb-NO", {
      minimumFractionDigits: hasDecimals ? 2 : 0,
      maximumFractionDigits: 2
    }).format(value)} kr`;
  }

  function parseNok(value) {
    let normalized = String(value || "")
      .replace(/\s/g, "")
      .replace(/kr/gi, "")
      .replace(/[^0-9.,-]/g, "");
    // Norsk format: punktum er tusenskille, komma er desimaltegn
    // ("1.395,00" → 1395.00). Uten komma tolkes punktum som tusenskille.
    if (normalized.includes(",")) {
      normalized = normalized.replace(/\./g, "").replace(",", ".");
    } else {
      normalized = normalized.replace(/\.(?=\d{3}(?:\D|$))/g, "");
    }
    const parsed = Number(normalized);
    return Number.isFinite(parsed) ? parsed : 0;
  }

  function readPurchaseSelection() {
    const purchase = document.querySelector("#bestill");
    const selected = purchase?.querySelector(".plan-list > .plan-card.selected");
    if (!selected) return null;

    const nameNode = selected.querySelector(".plan-name")?.cloneNode(true);
    nameNode?.querySelector(".plan-badge")?.remove();
    const name = nameNode?.textContent.trim() || "Olive X";
    const isSubscription = Boolean(selected.querySelector(".plan-badge"));
    const quantityValue = Number(selected.querySelector(".qty-num")?.textContent.trim());
    const quantity = Math.min(12, Math.max(1, Number.isFinite(quantityValue) ? quantityValue : 1));
    const unitPrice = parseNok(selected.querySelector(".plan-price strong")?.textContent);
    const comparePrice = parseNok(selected.querySelector(".plan-compare")?.textContent);
    const intervalButton = selected.querySelector(".interval-pill.selected");
    const interval = intervalButton?.dataset.olivexInterval
      || intervalButton?.textContent.trim().match(/^(30|60|90)/)?.[1]
      || selectedInterval;

    return {
      name,
      quantity,
      unitPrice,
      total: unitPrice * quantity,
      compareTotal: comparePrice > unitPrice ? comparePrice * quantity : 0,
      meta: isSubscription
        ? `500 ml · Levering hver ${interval}. dag`
        : "500 ml · Engangskjøp"
    };
  }

  function closePreviewCart() {
    const shell = document.querySelector("[data-olivex-preview-cart]");
    if (!shell || shell.hidden) return;

    shell.hidden = true;
    document.body.classList.remove("olivex-cart-is-open");
    document.body.style.removeProperty("--olivex-cart-scroll-offset");
    window.scrollTo({ top: cartScrollPosition, left: 0, behavior: "instant" });
    const returnTarget = cartOpenFrom?.isConnected
      ? cartOpenFrom
      : document.querySelector("#bestill .buy-widget > .btn.btn-primary");
    if (returnTarget) {
      window.requestAnimationFrame(() => returnTarget.focus({ preventScroll: true }));
    }
    cartOpenFrom = null;
  }

  function openPreviewCart(opener) {
    const selection = readPurchaseSelection();
    const shell = document.querySelector("[data-olivex-preview-cart]");
    if (!selection || !shell) return;

    shell.querySelector("[data-preview-cart-name]").textContent = selection.name;
    shell.querySelector("[data-preview-cart-meta]").textContent = selection.meta;
    shell.querySelector("[data-preview-cart-quantity]").textContent = String(selection.quantity);
    shell.querySelector("[data-preview-cart-line-total]").textContent = formatNok(selection.total);
    shell.querySelector("[data-preview-cart-total]").textContent = formatNok(selection.total);

    const compare = shell.querySelector("[data-preview-cart-compare]");
    compare.hidden = !selection.compareTotal;
    compare.textContent = selection.compareTotal ? formatNok(selection.compareTotal) : "";

    shell.querySelector("[data-preview-cart-content]").hidden = false;
    shell.querySelector("[data-preview-cart-empty]").hidden = true;
    shell.querySelector("[data-preview-cart-summary]").hidden = false;
    shell.querySelector("[data-preview-cart-live]").textContent = `${selection.name} er lagt i handlekurven.`;

    cartOpenFrom = opener;
    cartScrollPosition = window.scrollY;
    document.body.style.setProperty("--olivex-cart-scroll-offset", `${-cartScrollPosition}px`);
    shell.hidden = false;
    document.body.classList.add("olivex-cart-is-open");
    window.requestAnimationFrame(() => shell.querySelector("#olivex-preview-cart-title")?.focus({ preventScroll: true }));
  }

  function createPreviewCart() {
    const shell = document.createElement("div");
    shell.className = "olivex-preview-cart";
    shell.dataset.olivexPreviewCart = "";
    shell.hidden = true;
    shell.innerHTML = [
      '<div class="olivex-preview-cart__backdrop" data-preview-cart-dismiss aria-hidden="true"></div>',
      '<aside class="olivex-preview-cart__drawer" role="dialog" aria-modal="true" aria-labelledby="olivex-preview-cart-title" tabindex="-1">',
      '  <header class="olivex-preview-cart__header">',
      '    <div><p class="eyebrow">Bestilling</p><h2 id="olivex-preview-cart-title" tabindex="-1">Handlekurv</h2></div>',
      '    <button type="button" class="olivex-preview-cart__close" data-preview-cart-dismiss>Lukk</button>',
      '  </header>',
      '  <div class="olivex-preview-cart__content" data-preview-cart-content>',
      '    <article class="olivex-preview-cart__item">',
      '      <div class="olivex-preview-cart__item-copy"><h3 data-preview-cart-name></h3><p data-preview-cart-meta></p></div>',
      '      <div class="olivex-preview-cart__item-total"><span>Antall <strong data-preview-cart-quantity></strong></span><span data-preview-cart-compare hidden></span><strong data-preview-cart-line-total></strong></div>',
      '      <button type="button" class="olivex-preview-cart__remove" data-preview-cart-remove>Fjern</button>',
      '    </article>',
      '  </div>',
      '  <div class="olivex-preview-cart__empty" data-preview-cart-empty hidden><p>Handlekurven er tom.</p></div>',
      '  <footer class="olivex-preview-cart__summary" data-preview-cart-summary>',
      '    <div><span>Totalt</span><strong data-preview-cart-total></strong></div>',
      '    <button type="button" class="btn btn-primary" data-preview-cart-dismiss>Fortsett å handle</button>',
      '  </footer>',
      '  <p class="olivex-video-status" aria-live="polite" data-preview-cart-live></p>',
      '</aside>'
    ].join("");
    return shell;
  }

  function ensurePreviewCart() {
    let shell = document.querySelector("[data-olivex-preview-cart]");
    if (shell) return;

    shell = createPreviewCart();
    document.body.append(shell);

    shell.querySelectorAll("[data-preview-cart-dismiss]").forEach((control) => {
      control.addEventListener("click", closePreviewCart);
    });

    shell.querySelector("[data-preview-cart-remove]")?.addEventListener("click", () => {
      shell.querySelector("[data-preview-cart-content]").hidden = true;
      shell.querySelector("[data-preview-cart-empty]").hidden = false;
      shell.querySelector("[data-preview-cart-summary]").hidden = true;
      shell.querySelector("[data-preview-cart-live]").textContent = "Varen er fjernet fra handlekurven.";
      shell.querySelector(".olivex-preview-cart__close")?.focus({ preventScroll: true });
    });
  }

  function ensurePurchaseOptions() {
    const purchase = document.querySelector("#bestill");
    if (!purchase) return;

    // Intervallknappene og fraktlinjen rendres naa i Liquid fra selling plans
    // (sections/olivex-draft.liquid). Her settes bare tilgjengelighet paa antall.
    purchase.querySelectorAll(".qty-stepper").forEach((stepper) => {
      const buttons = stepper.querySelectorAll(".qty-btn");
      const value = Number(stepper.querySelector(".qty-num")?.textContent.trim());
      if (buttons.length < 2 || !Number.isFinite(value)) return;

      buttons[0].setAttribute("aria-label", "Reduser antall");
      buttons[1].setAttribute("aria-label", "Øk antall");
      buttons[0].disabled = value <= 1;
      buttons[1].disabled = value >= 12;
      buttons[0].setAttribute("aria-disabled", buttons[0].disabled ? "true" : "false");
      buttons[1].setAttribute("aria-disabled", buttons[1].disabled ? "true" : "false");
    });
  }

  // ------------------------------------------------------------------
  // Dokumentviser: sertifikater åpnes i en integrert overlay på desktop.
  // På mobil/iPad beholdes nettleserens native visning (innebygd PDF i
  // iframe er upålitelig på iOS), så lenken får gjøre jobben selv der.
  // ------------------------------------------------------------------
  let documentViewerOpenFrom = null;

  function documentViewerSupported() {
    const isIosLike = /iP(hone|ad|od)/.test(navigator.platform)
      || (navigator.maxTouchPoints > 1 && /Mac/.test(navigator.platform));
    return window.matchMedia("(min-width: 820px)").matches && !isIosLike;
  }

  function createDocumentViewer() {
    const shell = document.createElement("div");
    shell.className = "olivex-doc-viewer";
    shell.dataset.olivexDocViewer = "";
    shell.hidden = true;
    shell.innerHTML = [
      '<div class="olivex-doc-viewer__backdrop" data-doc-viewer-dismiss aria-hidden="true"></div>',
      '<section class="olivex-doc-viewer__panel" role="dialog" aria-modal="true" aria-labelledby="olivex-doc-viewer-title">',
      '  <header class="olivex-doc-viewer__header">',
      '    <div class="olivex-doc-viewer__heading"><p class="eyebrow">Dokumentasjon</p><h2 id="olivex-doc-viewer-title" tabindex="-1"></h2></div>',
      '    <div class="olivex-doc-viewer__actions">',
      '      <a class="olivex-doc-viewer__action" data-doc-viewer-open href="#" target="_blank" rel="noopener noreferrer">Åpne i ny fane</a>',
      '      <a class="olivex-doc-viewer__action" data-doc-viewer-download href="#" download>Last ned</a>',
      '      <button type="button" class="olivex-doc-viewer__close" data-doc-viewer-dismiss>Lukk</button>',
      '    </div>',
      '  </header>',
      '  <div class="olivex-doc-viewer__body" data-doc-viewer-body></div>',
      '</section>'
    ].join("");
    return shell;
  }

  function ensureDocumentViewer() {
    let shell = document.querySelector("[data-olivex-doc-viewer]");
    if (shell) return shell;
    shell = createDocumentViewer();
    document.body.append(shell);
    shell.querySelectorAll("[data-doc-viewer-dismiss]").forEach((control) => {
      control.addEventListener("click", closeDocumentViewer);
    });
    return shell;
  }

  // FLIP: panelet vokser ut fra kortet man klikket paa, slik at det leses som
  // et lag over siden — ikke som en ny fane. Returnerer en promise som er
  // ferdig naar bevegelsen er over (eller med en gang ved reduced motion).
  function animateDocumentViewer(shell, origin, opening) {
    const panel = shell.querySelector(".olivex-doc-viewer__panel");
    const backdrop = shell.querySelector(".olivex-doc-viewer__backdrop");
    const header = shell.querySelector(".olivex-doc-viewer__header");
    const body = shell.querySelector("[data-doc-viewer-body]");
    const reduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

    if (reduced || !panel || typeof panel.animate !== "function" || !origin) {
      return Promise.resolve();
    }

    const rect = origin.getBoundingClientRect();
    const width = Math.max(1, window.innerWidth);
    const height = Math.max(1, window.innerHeight);
    const collapsed = {
      transform: `translate(${rect.left}px, ${rect.top}px) scale(${(rect.width / width).toFixed(4)}, ${(rect.height / height).toFixed(4)})`,
      borderRadius: "12px",
      // Nesten ugjennomsiktig: flaten skal lese som at kortet vokser,
      // ikke som at et spoekelse toner inn.
      opacity: 0.92
    };
    const expanded = { transform: "translate(0px, 0px) scale(1, 1)", borderRadius: "0px", opacity: 1 };
    const frames = opening ? [collapsed, expanded] : [expanded, collapsed];
    const duration = opening ? 460 : 320;
    const easing = opening ? "cubic-bezier(0.22, 1, 0.36, 1)" : "cubic-bezier(0.4, 0, 0.7, 0.2)";

    const running = [panel.animate(frames, { duration, easing, fill: "both" })];
    running.push(backdrop.animate(
      opening ? [{ opacity: 0 }, { opacity: 1 }] : [{ opacity: 1 }, { opacity: 0 }],
      { duration: opening ? 280 : 260, easing: "ease-out", fill: "both" }
    ));
    // Innholdet tones inn etter at flaten har vokst ut, ellers ser man teksten
    // bli strukket av den ikke-uniforme skaleringen.
    [header, body].forEach((part) => {
      if (!part) return;
      running.push(part.animate(
        opening ? [{ opacity: 0 }, { opacity: 0 }, { opacity: 1 }] : [{ opacity: 1 }, { opacity: 0 }],
        { duration: opening ? 520 : 180, easing: "ease-out", fill: "both" }
      ));
    });

    return Promise.all(running.map((animation) => animation.finished.catch(() => {})))
      .then(() => running.forEach((animation) => animation.cancel()));
  }

  function closeDocumentViewer() {
    const shell = document.querySelector("[data-olivex-doc-viewer]");
    if (!shell || shell.hidden || shell.dataset.olivexDocClosing === "true") return;
    const returnTarget = documentViewerOpenFrom?.isConnected
      ? documentViewerOpenFrom
      : null;

    shell.dataset.olivexDocClosing = "true";
    animateDocumentViewer(shell, returnTarget, false).then(() => {
      delete shell.dataset.olivexDocClosing;
      shell.hidden = true;
      shell.querySelector("[data-doc-viewer-body]").replaceChildren();
      document.documentElement.style.removeProperty("overflow");
      document.documentElement.style.removeProperty("padding-right");
      if (returnTarget) returnTarget.focus({ preventScroll: true });
      documentViewerOpenFrom = null;
    });
  }

  function openDocumentViewer(link) {
    const shell = ensureDocumentViewer();
    const label = link.cloneNode(true);
    label.querySelector("svg")?.remove();
    label.querySelector("span")?.remove();
    const name = label.textContent.trim().replace(/\s+/g, " ") || "Dokument";

    shell.querySelector("#olivex-doc-viewer-title").textContent = name;
    const openAction = shell.querySelector("[data-doc-viewer-open]");
    const downloadAction = shell.querySelector("[data-doc-viewer-download]");
    openAction.href = link.href;
    const sameOrigin = new URL(link.href, window.location.href).origin === window.location.origin;
    downloadAction.hidden = !sameOrigin;
    if (sameOrigin) downloadAction.href = link.href;

    const body = shell.querySelector("[data-doc-viewer-body]");
    if (/\.pdf(?:[?#]|$)/i.test(link.href)) {
      const frame = document.createElement("iframe");
      frame.className = "olivex-doc-viewer__frame";
      frame.src = link.href + "#toolbar=0&navpanes=0&view=FitH&zoom=page-width";
      frame.title = name;
      body.replaceChildren(frame);
    } else {
      const scroller = document.createElement("div");
      scroller.className = "olivex-doc-viewer__scroller";
      const image = document.createElement("img");
      image.src = link.href;
      image.alt = name;
      image.decoding = "async";
      scroller.append(image);
      body.replaceChildren(scroller);
    }

    documentViewerOpenFrom = link;
    shell.hidden = false;
    // Kompenser for rullefeltet slik at siden bak ikke hopper naar den laases.
    const scrollbar = window.innerWidth - document.documentElement.clientWidth;
    if (scrollbar > 0) document.documentElement.style.paddingRight = `${scrollbar}px`;
    document.documentElement.style.overflow = "hidden";
    animateDocumentViewer(shell, link, true);
    window.requestAnimationFrame(() => shell.querySelector(".olivex-doc-viewer__close")?.focus({ preventScroll: true }));
  }

  function applyApprovedDeltas() {
    applyQueued = false;
    ensureVideo();
    ensureEditorialSections();
    ensureReferences();
    ensurePurchaseOptions();
  }

  function scheduleApply() {
    if (applyQueued) return;
    applyQueued = true;
    window.requestAnimationFrame(applyApprovedDeltas);
  }

  document.addEventListener("click", (event) => {

    const blockedDocument = event.target.closest?.('[data-olivex-missing-document="true"]');
    if (blockedDocument) {
      event.preventDefault();
      return;
    }

    const certificate = event.target.closest?.("#lab .certs a.cert");
    if (certificate && documentViewerSupported()
      && !event.metaKey && !event.ctrlKey && !event.shiftKey && !event.altKey) {
      event.preventDefault();
      openDocumentViewer(certificate);
      return;
    }

  }, true);

  document.addEventListener("keydown", (event) => {
    const viewer = document.querySelector("[data-olivex-doc-viewer]");
    if (viewer && !viewer.hidden) {
      if (event.key === "Escape") {
        event.preventDefault();
        closeDocumentViewer();
        return;
      }
      if (event.key === "Tab") {
        const focusable = Array.from(viewer.querySelectorAll('a[href]:not([hidden]), button:not([disabled])'))
          .filter((element) => element.getClientRects().length > 0);
        if (!focusable.length) return;
        const first = focusable[0];
        const last = focusable[focusable.length - 1];
        if (event.shiftKey && document.activeElement === first) {
          event.preventDefault();
          last.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
          event.preventDefault();
          first.focus();
        }
      }
      return;
    }

    const shell = document.querySelector("[data-olivex-preview-cart]");
    if (!shell || shell.hidden) return;

    if (event.key === "Escape") {
      event.preventDefault();
      closePreviewCart();
      return;
    }

    if (event.key !== "Tab") return;
    const focusable = Array.from(shell.querySelectorAll([
      "button:not([disabled])",
      "a[href]",
      '[tabindex]:not([tabindex="-1"])'
    ].join(","))).filter((element) => !element.hidden && element.getClientRects().length > 0);
    if (!focusable.length) return;

    const first = focusable[0];
    const last = focusable[focusable.length - 1];
    const dialog = shell.querySelector('[role="dialog"]');
    const title = shell.querySelector("#olivex-preview-cart-title");
    if (event.shiftKey && (document.activeElement === first || document.activeElement === dialog || document.activeElement === title)) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  });

  const observer = new MutationObserver(scheduleApply);
  observer.observe(document.documentElement, { childList: true, characterData: true, subtree: true });

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", scheduleApply, { once: true });
  } else {
    scheduleApply();
  }
})();
